export default "__VITE_ASSET__ByRW5RCH__"